import type { PaymentRun, PaymentRunDetail } from '@/lib/api/billing';

type Schritt = { label: string; hinweis: string };

/**
 * Der Zahlungslauf als Ablauf (T-0138) — wie die Schritt-für-Schritt-Assistenten:
 * oben die Schritte, darunter, was als Nächstes zu tun ist. Die Knöpfe dazu
 * stehen wie bisher im Dialog darunter.
 */
export function ablaufSchritte(run: PaymentRun): Schritt[] {
  const datei = run.provider === 'hausbank_sepa';
  const lastschrift = run.direction !== 'credit';
  if (datei) {
    return [
      { label: 'Entwurf prüfen', hinweis: 'Aufträge und Beträge unten prüfen. Passt alles, den Lauf freigeben.' },
      {
        label: 'Freigeben',
        hinweis: lastschrift
          ? 'Mit „Freigeben und Zahler informieren“ gehen die Vorabinformationen an die Zahler.'
          : 'Den Lauf freigeben.',
      },
      { label: 'Bankdatei', hinweis: '„Bankdatei erzeugen“ — danach liegt die SEPA-Datei zum Herunterladen bereit.' },
      {
        label: 'Einreichen',
        hinweis: (run as Partial<PaymentRunDetail>).ebicsReady
          ? '„Per EBICS übertragen“ und den Auftrag in der Banking-App freigeben.'
          : 'Datei herunterladen, im Onlinebanking hochladen und hier „Upload bestätigen“.',
      },
      {
        label: 'Verbuchen',
        hinweis: 'Ab dem Einzugstag die Einzüge verbuchen; Rücklastschriften je Auftrag erfassen.',
      },
    ];
  }
  return [
    { label: 'Entwurf prüfen', hinweis: 'Aufträge und Beträge unten prüfen. Passt alles, den Lauf freigeben.' },
    { label: 'Freigeben', hinweis: 'Den Lauf freigeben.' },
    { label: 'Einreichen', hinweis: '„Einreichen“ übergibt die Aufträge an den Zahlungsanbieter.' },
    { label: 'Verbuchen', hinweis: 'Zahlungseingänge je Auftrag erfassen, sobald sie da sind.' },
  ];
}

/** Welcher Schritt dran ist (1-basiert); nach dem letzten ist alles erledigt. */
export function aktuellerSchritt(run: PaymentRun): number {
  const datei = run.provider === 'hausbank_sepa';
  switch (run.status) {
    case 'draft':
      return 1;
    case 'approved':
      return 3;
    case 'exported':
      return 4;
    case 'submitted':
      return datei ? 5 : 4;
    case 'settled':
      return datei ? 6 : 5;
    default:
      return 0;
  }
}

